import { Component } from 'react';

export class ErrorBoundary extends Component<
  { onError: React.Dispatch<Error | undefined>; children: React.ReactNode },
  { error: boolean }
> {
  state = { error: false };
  static getDerivedStateFromError = () => ({ error: true });
  componentDidCatch(err: Error) {
    this.props.onError(err);
  }
  render() {
    return this.state.error ? null : this.props.children;
  }
}
